import React from "react";
import { MenuItem, SiteTheme } from "../../types/types";
import Menu from "./Menu";
import Search from "./Search";
import { useMediaQuery } from "@mantine/hooks";
import { getLogoHeight, getLogoWidth } from "../../utils";

interface HeaderProps {
    logoSrc: string | null;
    menuItems: MenuItem[];
    searchPageUrl: string;
    siteTheme: SiteTheme;
}

const Header: React.FC<HeaderProps> = ({
    logoSrc,
    menuItems,
    searchPageUrl,
    siteTheme,
}) => {
    const isMobile = useMediaQuery("(max-width: 768px)", false, { getInitialValueInEffect: false });
    const logoHeight = getLogoHeight(siteTheme, isMobile);
    const logoWidth = getLogoWidth(siteTheme, isMobile);

    return (
        <>
            <Menu menuItems={menuItems} siteTheme={siteTheme} />
            <a
                href="/"
                aria-label="Startsidan"
                title="Till startsidan"
                data-gtm-click-type="home"
                className="home-link"
            >
                <img
                    alt=""
                    className="home"
                    height={logoHeight ?? undefined}
                    src={logoSrc!}
                    width={logoWidth ?? undefined}
                />
                {/* TODO: have a backup src instead of ! */}
            </a>
            <Search searchPageUrl={searchPageUrl} />
        </>
    );
};

export default Header;
